/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface PropChallengePackageTag
 */
export class PropChallengePackageTag {
    /**
     *
     * @type {string}
     * @memberof PropChallengePackageTag
     */
    type: PropChallengePackageTagTypeEnum;
    /**
     *
     * @type {string}
     * @memberof PropChallengePackageTag
     */
    color: PropChallengePackageTagColorEnum;
}

/**
 * @export
 * @enum {string}
 */
export enum PropChallengePackageTagTypeEnum {
    Popular = 'popular',
    New = 'new',
    Featured = 'featured',
    LimitedTime = 'limitedTime',
    BestValue = 'bestValue',
}
/**
 * @export
 * @enum {string}
 */
export enum PropChallengePackageTagColorEnum {
    Primary = 'primary',
    Secondary = 'secondary',
    Error = 'error',
    Warning = 'warning',
    Success = 'success',
}
